<template lang="pug">
  .category-products.container.mx-auto.my-4(ref="container")
    .loading(v-if="loading")
      //- TODO: skeleton
      Spinner(:size="10" :thickness="2")

    .teasers(v-else-if="teasers && teasers.length")
        .filters
          .search
            input(type="text" class="border" name="search" id="search" placeholder="Suchen")
          .group.group-1
            .select-wine
              <select class="w-full border bg-white rounded px-3 py-2 outline-none"><option value="" disabled selected>Wein auswählen</option><option class="py-1">Option 1</option><option class="py-1">Option 2</option><option class="py-1">Option 3</option></select>
            .select-year
              <select class="w-full border bg-white rounded px-3 py-2 outline-none"><option value="" disabled selected>Jahrgang</option><option class="py-1">Option 1</option><option class="py-1">Option 2</option><option class="py-1">Option 3</option></select>
          .group.group-2
            .price-min
              input(type="text" class="border" name="minPrice" id="minPrice" placeholder="Min Preis")
            .price-max
              input(type="text" class="border" name="maxPrice" id="maxPrice" placeholder="Max Preis")

        .product-table
          .theader
            .table_header.type 
            .table_header.year Jahr
            .table_header.liter Liter
            .table_header.wine Wein
            .table_header.region Region / Erzeuger
            .table_header.points Punkte
            .table_header.info Info*
            .table_header.img
            .table_header.qty Fl.
            .table_header.price €/Fl.
            .table_header.pa §
            .table_header.addToCart
          Teaser(
            v-for="teaser in teasers"
            :key="teaser.id"
            v-if="teaser"
            :teaser="teaser"
            display="row"
          )
          //- TODO
    .not-found(v-else)
      .notification Bisher gibt es hier noch keine Produkte.
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import justifiedLayout from 'justified-layout';
// import Multiselect from 'vue-multiselect';

import router from '@/router';
import { get, cloneDeep, debounce } from '@/helpers';

import Teaser from './Teaser';
import Pagination from '@/components/Pagination';

import TilesIcon from '@/assets/svgs/tiles-icon.svg';

export default {
    name: 'CategoryProducts',
    props: {
        section: {
            type: Object,
            required: true
        },
        perPage: {
            type: Number,
            default: 24
        },
        defaultOrientation: {
            type: String,
            default: 'horizontal',
            validator: val => ['horizontal', 'vertical', 'justified'].includes(val)
        },
        forcedOrientation: {
            type: String,
            validator: val => ['horizontal', 'vertical', 'justified'].includes(val)
        }
    },
    data: () => ({
        currentPage: 1,
        products: undefined,
        loading: false,

        showFilters: false,
        justifiedLayoutConfig: {
            containerWidth: undefined,
            containerPadding: {
                top: undefined,
                right: undefined,
                bottom: undefined,
                left: undefined
            },
            boxSpacing: {
                horizontal: 16,
                vertical: 70 + 16
            },
            targetRowHeight: 350
        }
    }),
    components: {
        Teaser,
        TilesIcon,
        Pagination
        // Multiselect
    },
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch();
        }
    },
    computed: {
        s() {
            return this.sections.findIndex(el => el.id === this.section.id);
        },
        teasers() {
            let teasers = [];

            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.perPage);
                else teasers = new Array(1);
            } else {
                teasers = get(this.products, 'items') || [];
            }

            teasers.forEach(teaser => {
                let media = get(teaser, 'media');
                if (media && media.length) {
                    media = media.find(el => get(el, 'settings.show.list') === true);

                    if (media !== undefined) {
                        teaser.media = media;
                        switch (media.type) {
                            case 'image':
                                teaser.ratio = media.image.width / media.image.height;
                                break;

                            // TODO
                            // handle videos and files
                            case 'video':
                                teaser.ratio = 16 / 9;
                                break;

                            default:
                                teaser.ratio = 1;
                        }
                    }
                } else {
                    delete teaser.media;
                    teaser.ratio = 1;
                }
            });

            return teasers;
        },
        pageInfo() {
            return (
                get(this.products, 'pageInfo') || {
                    currentPage: 1,
                    lastPage: 1,
                    total: 0,
                    perPage: this.perPage
                }
            );
        },
        layoutGeometry() {
            const ratios = this.teasers.map(el => el.ratio);
            return justifiedLayout(ratios, this.justifiedLayoutConfig);
        },
        tiles() {
            let tiles = [];
            this.teasers.forEach((teaser, i) => {
                const style = this.layoutGeometry.boxes[i];

                let tile = { ...teaser, ...{ style } };
                delete tile.ratio;

                tile.style.height += 70;

                tiles.push(tile);
            });
            return tiles;
        },
        settings() {
            return this.section.settings || [];
        },
        orientationOptions() {
            const setting = this.settings.find(el => el.key === 'display-types');
            if (!setting || !setting.options || !setting.options.length) return ['card', 'row', 'tile'];
            else return setting.options.map(el => el.key);
        },
        activeOrientation() {
            if (this.forcedOrientation) return this.forcedOrientation;
            let orientation = this.defaultOrientation;

            switch (this.preferredOrientation) {
                case 'horizontal':
                    if (this.orientationOptions.includes('card')) orientation = this.preferredOrientation;
                    break;

                case 'vertical':
                    if (this.orientationOptions.includes('row')) orientation = this.preferredOrientation;
                    break;

                case 'justified':
                    if (this.orientationOptions.includes('tile')) orientation = this.preferredOrientation;
                    break;
            }

            const orientations = { card: 'horizontal', row: 'vertical', tile: 'justified' };
            return orientation || orientations[this.orientationOptions[0]];
        },
        ...mapGetters({
            cms: 'CMS',
            sections: 'sections',
            preferredOrientation: 'shop/preferredListOrientation'
        })
    },
    methods: {
        changePage(currentPage) {
            if (this.$refs.list) {
                this.$refs.list.scrollIntoView({
                    behavior: 'smooth'
                });
            }

            if (currentPage > 1) {
                let query = {};
                query[`P${this.section.id}`] = currentPage;
                router.push({ query });
            } else {
                router.push({ query: null });
            }

            this.currentPage = currentPage;
            this.refetch();
        },
        refetch() {
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            let categories = [];

            let c = undefined;
            if ((c = get(this.section, 'shopCategories'))) {
                categories = c.map(category => category.id);
            }

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: this.perPage
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'categories',
                        in: categories
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'date' // property:groupsort
            };
            this.fetchProducts(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        },
        ...mapMutations({
            // updateTeasersLoading: 'updateTeasersLoading',
            // insertTeasers: 'insertTeasers',
            // addFilter: 'addFilter',
            // updateFilter: 'updateFilter',
            // insertPageInfo: 'insertPageInfo',
            setPreferredOrientation: 'shop/setPreferredListOrientation'
        }),
        ...mapActions({
            fetchProducts: 'shop/fetchProductsPaginated'
        })
    },
    mounted() {
        const products = { loading: true, pagination: {} };
        this.products = products;
        // this.insertProducts({ products });

        this.currentPage = get(this.$route, `query.P${this.section.id}`) || 1;
        // this.currentPage = 1;
        this.refetch();

        // if (this.orientation === 'justified') {
        const calculateDimansions = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container);
                this.justifiedLayoutConfig.containerWidth = this.$refs.container.offsetWidth;
                this.justifiedLayoutConfig.containerWidth -=
                    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

                this.justifiedLayoutConfig.containerPadding = {
                    top: parseInt(style.paddingTop),
                    right: 0,
                    bottom: parseInt(style.paddingBottom) + 70,
                    left: 0
                };
            }
        };

        window.addEventListener('resize', debounce(calculateDimansions, 100));
        calculateDimansions();
        // }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"


.filters
  @apply my-4 mx-4 flex flex-col
  @screen lg
    @apply flex-row my-8 mx-0
    > div
      margin-right: 10px
  input, select
    border-color: $maisonvin-border
    line-height: 37px
    height: 37px
    &::placeholder
      color: $maisonvin-base-text
      opacity: 1

  .group
    @apply flex
    > div
      margin-top: 10px
      width: 50%
      @screen lg
        margin-top: 0
      &:first-of-type
        margin-right: 5px
      &:last-of-type
        margin-left: 5px
    &.group-1
      @screen lg
        min-width: 350px

  .price-min,
  .price-max
    @screen lg
      input
        max-width: 120px

.product-table
    @apply block w-full border-separate text-base px-4
    @screen lg
      @apply table p-0
    .theader
        @apply hidden
        @screen lg
          @apply table-row
        .table_header
            @apply table-cell font-semibold border-t border-b border-r
            padding: 6px 10px
            border-color: $maisonvin-border
            &:first-child
                @apply border-l
            &.year,
            &.liter,
            &.qty,
            &.pa
              @apply text-center

            &.region
              @screen lg
                min-width: 180px


    .table_row
      @apply transition duration-200 ease-linear
      @screen lg
        &:hover
          background: rgba($maisonvin-red-dark, 0.1)

.loading > section
  min-height: 140px
.category-products
  display: flex
  flex-grow: 1
  .loading
    display: flex
    width: 100%
  .teasers
    width: 100%
  .paginated-teasers
    &.horizontal
      grid-template-columns: 1fr
      grid-gap: 1rem
      align-content: space-around
      justify-content: space-between
      @screen sm
        grid-template-columns: repeat(2, 300px)
      @screen lg
        grid-template-columns: repeat(3, 300px)
      @screen xl
        grid-template-columns: repeat(4, 300px)
    &.vertical
      // TODO
    &.justified
      position: relative
</style>
